import { render, staticRenderFns } from "./ModalPatientTasksList.vue?vue&type=template&id=f66f6cd0&scoped=true&lang=pug"
import script from "./ModalPatientTasksList.vue?vue&type=script&lang=js"
export * from "./ModalPatientTasksList.vue?vue&type=script&lang=js"
import style0 from "./ModalPatientTasksList.vue?vue&type=style&index=0&id=f66f6cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66f6cd0",
  null
  
)

export default component.exports